import {configureStore} from '@reduxjs/toolkit';
import {runSagas} from 'modules/sagas';
import middleware from './middleware';
import reducer from './reducer';

export default configureStore({
    reducer,
    middleware,
    devTools: process.env.NODE_ENV !== 'production',
});

runSagas();
